import type { Namespace } from '../types';

// DE drafted — queued for native review. Sentinel Mobile Agent (R-147 W6): the
// technician's phone surface — bottom-nav shell, My-Work list, task detail,
// scan and profile. Domain vocabulary (resolution codes, TO stages, scan
// strings) is reused from siteItsm / workOrders / transferOrders / siteAssets.
export const technician = {
  // Shell + bottom nav
  bottomNavLabel: { de: 'Hauptnavigation', en: 'Primary' },
  navHome: { de: 'Start', en: 'Home' },
  navWork: { de: 'Meine Arbeit', en: 'My Work' },
  navScan: { de: 'Scannen', en: 'Scan' },
  navProfile: { de: 'Profil', en: 'Profile' },
  offline: { de: 'Offline', en: 'Offline' },
  queuedBadge: { de: '{count} wartet', en: '{count} queued' },

  // Home
  greeting: { de: 'Hallo, {name}', en: 'Hello, {name}' },
  homeDesc: { de: 'Deine Einsätze an diesem Standort.', en: 'Your assignments at this site.' },
  statMyIncidents: { de: 'Meine Incidents', en: 'My incidents' },
  statMyWos: { de: 'Meine Aufträge', en: 'My work orders' },
  connOnline: { de: 'Online', en: 'Online' },
  connOffline: {
    de: 'Offline — Änderungen werden zwischengespeichert',
    en: 'Offline — changes are queued',
  },
  goWork: { de: 'Meine Arbeit öffnen', en: 'Open my work' },
  goScan: { de: 'Asset scannen', en: 'Scan an asset' },

  // My Work list
  emptyTitle: { de: 'Nichts zu tun', en: 'Nothing to do' },
  emptyMsg: {
    de: 'Keine offenen Incidents oder Aufträge für dich.',
    en: 'No open incidents or work orders for you.',
  },
  loadError: { de: 'Laden fehlgeschlagen', en: 'Failed to load' },
  accept: { de: 'Annehmen & losfahren', en: 'Accept & travel' },
  resume: { de: 'Weiterarbeiten', en: 'Resume work' },
  slaLeft: { de: 'SLA {left}', en: 'SLA {left}' },
  due: { de: 'Fällig {date}', en: 'Due {date}' },
  unassigned: { de: 'Nicht zugewiesen', en: 'Unassigned' },
  offlineHint: { de: 'Offline — erst mit Verbindung möglich', en: 'Offline — needs a connection' },

  // Task detail
  notFound: { de: 'Datensatz nicht gefunden', en: 'Record not found' },
  scanAsset: { de: 'Asset scannen', en: 'Scan asset' },
  captureSignature: { de: 'Unterschrift erfassen', en: 'Capture signature' },
  signatureSave: { de: 'Unterschrift hochladen', en: 'Upload signature' },
  signatureEmpty: { de: 'Bitte zuerst unterschreiben.', en: 'Please sign first.' },

  // Swap preparation (CTASK)
  swapTitle: { de: 'Tauschvorbereitung', en: 'Swap preparation' },
  faultyUnit: { de: 'Defektes Gerät', en: 'Faulty unit' },
  spareNext: { de: 'Nächstes Ersatzgerät', en: 'Next spare' },
  spareNone: {
    de: 'Kein verfügbares Ersatzgerät dieser Klasse im Lager.',
    en: 'No available spare of this class in stock.',
  },
  reserveSpare: { de: 'Ersatzgerät reservieren', en: 'Reserve spare' },
  deliverTo: { de: 'Lieferziel', en: 'Deliver to' },
  returnFaulty: { de: 'Defektes Gerät zurückführen', en: 'Return faulty unit' },
  returnDest: { de: 'Rückgabeort', en: 'Return location' },
  transferOrdersTitle: { de: 'Transportaufträge', en: 'Transfer orders' },

  // Profile
  language: { de: 'Sprache', en: 'Language' },
  queueTitle: { de: 'Offline-Warteschlange', en: 'Offline queue' },
  queueEmpty: { de: 'Keine ausstehenden Änderungen.', en: 'No pending changes.' },
  parked: { de: 'Geparkt', en: 'Parked' },
  discard: { de: 'Verwerfen', en: 'Discard' },
} satisfies Namespace;
